import { render } from "./productAddNewColorDialog.vue?vue&type=template&id=9cc343b8"
import script from "./productAddNewColorDialog.vue?vue&type=script&lang=js"
export * from "./productAddNewColorDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__